export default __webpack_public_path__ + "static/media/aud-flag.3550d2d8.svg";